module.exports = __webpack_public_path__ + "static/media/6.3.443ac1b9.zip";